module.exports = __webpack_public_path__ + "static/media/27OCHA10.a8e5ddf2.jpg";